import { helper } from '@ember/component/helper';

// NOOP is shared so repeated renders get a stable identity — `{{on}}` tears
// down and reinstalls its listener whenever the handler changes identity.
const NOOP = () => {};

// optional guarantees `{{on}}` receives a function.
//
// `{{on}}` calls `.bind` on whatever it is given, so a handler supplied by the
// caller and defaulted to `null` blows up with "Cannot read properties of
// undefined (reading 'bind')" the moment a caller omits it. `{{action}}`
// tolerated this; `{{on}}` does not, which is why it surfaced during the
// action -> on migration.
//
// A modifier cannot be wrapped in `{{#if}}` (block syntax is not allowed in
// element space), so guard the value instead:
//
//   {{on "click" (optional this.onClick)}}
//   {{on "click" (fn (optional this.onSelect) item)}}
export default helper(function optional([maybeFunction]) {
  return typeof maybeFunction === 'function' ? maybeFunction : NOOP;
});
